import { useEffect } from "react";
import { useDispatch,useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loggedInUser,signoutAsync } from "../Auth_Slice";
import { resetCartSlice } from "../../Cart/Cart_Slice";
import { resetUserSlice } from "../../User/userSlice";
import toast from "react-hot-toast"


function Logout() {
    const dispatch = useDispatch();
    const user = useSelector(loggedInUser);
    const navigate = useNavigate();
    
    useEffect(()=>{
            if(user){
                dispatch(signoutAsync()).then((response) => {
                    if (response.payload.status === 'success') {
                        dispatch(resetCartSlice())
                        dispatch(resetUserSlice())
                        toast.success("Logged Out!",{id:"success"});
                      navigate("/login");
                  } 
                  else {
                    // Handle signout failure
                    toast.error(response.payload.message,{id:"error"});
                }
               })
            }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])
    return null;
     
}

export default Logout;